import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {SessionService} from '../../../../services/session.service';
import {DialogService} from '../../../../services/dialog.service';
import {Router} from '@angular/router';
import {redirectToLink} from '../../constants';

@Component({
    selector: 'app-menu-movil',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss']
})
export class MenuMovilComponent implements OnInit {
    inSessionFlag: boolean;

    constructor(
        private matDialogRef: MatDialogRef<MenuMovilComponent>,
        private sessionService: SessionService,
        private dialogService: DialogService,
        public router: Router
    ) {
    }

    ngOnInit(): void {
    }

    inSession(): boolean {
        const auth = this.sessionService.getAuthData();
        let sess;
        if (auth) {
            if (this.sessionService.getDayExpiration() !== String(new Date().getDate() + '/' + new Date().getMonth())) {
                this.sessionService.newDataSession();
                window.location.reload();
            } else {
                sess = this.sessionService.getLoginSession();
            }
        }
        return (auth != null && sess != null && auth !== '' && sess !== '' && auth !== 'null' && sess !== 'null');
    }

    close(): void {
        this.matDialogRef.close();
    }

    abrirLogin(): void {
        redirectToLink('https://clientes.firmaautografa.com/login');
    }

    login(isLogIn: boolean): void {
        this.inSessionFlag = this.inSession();
        if (this.inSessionFlag) {
            this.dialogService.showConfirmationDialog(
                'Confirmar Operação',
                'Tem certeza que deseja encerrar a Sessão?',
                () => {
                    sessionStorage.clear();
                    localStorage.clear();
                    this.router.navigate(['/']);
                }
            );
        } else {
            if (isLogIn) {
                if (this.inSessionFlag) {
                    this.sessionService.clearData();
                } else {
                    this.setInitText(false);
                }
            } else {
                this.setInitText(true);
            }
        }
    }

    setInitText(value): void {
        this.sessionService.setInitText(value);
        setTimeout(() => {
            if (this.router.url === '/assinatura-digital-gratis') {
                this.sessionService.emitNewSessionText(value);
            } else {
                this.router.navigate(['/assinatura-digital-gratis']);
            }
        }, 200);
    }

    changeLanguage(): void {
        window.location.href = 'https://fad.firmaautografa.com/';
    }
}
